// extracted by mini-css-extract-plugin
export default {"CollapsableContainer":"CollapsableContainer_CollapsableContainer__STyzy","header":"CollapsableContainer_header__CjkvW"};